import { render, staticRenderFns } from "./MortgageDeals.vue?vue&type=template&id=72c77d4c&scoped=true&"
import script from "./MortgageDeals.vue?vue&type=script&lang=js&"
export * from "./MortgageDeals.vue?vue&type=script&lang=js&"
import style0 from "./MortgageDeals.vue?vue&type=style&index=0&id=72c77d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c77d4c",
  null
  
)

export default component.exports